/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_SigninInputs */

const en_cc_signin = /** @type {(inputs: Cc_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in in a new tab`)
};

const id_cc_signin = /** @type {(inputs: Cc_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk di tab baru`)
};

/**
* | output |
* | --- |
* | "Sign in in a new tab" |
*
* @param {Cc_SigninInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_signin = /** @type {((inputs?: Cc_SigninInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_SigninInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_signin(inputs)
	return en_cc_signin(inputs)
});